<template>
  <div class="home">
    <banner :data="banners"/>
    <!-- 轮播Banner -->
    <!-- <swiper :height="'300px'" :navigation="false" ref="swiper" style="box-shadow: 0 3px 18px 0 rgba(35,55,73,0.35)">
      <swiper-item v-for="(item, index) in banners" :key="index">
        <div class="cover-wrapper" :style="{height:'300px',backgroundImage:'url(' + item.url + ')'}">
          <a :href="item.src" :target="item.target"><img :src="item.url"></a>
        </div>
      </swiper-item>
    </swiper> -->
    <floating></floating>
    <div class="section-container production">
      <div class="main-container">
        <!-- 产品展示 -->
        <div class="production__show">
          <ul class="clearfix show__box">
            <li class="show__item" v-for="(item, index) in sceneList" :key="item.id" v-show="!(isMoreShow&&index>3)">
              <div class="show__top" @click="onSceneClick(item)">
                <div class="show__img">
                  <img :src="item.picUrl" :alt="item.name">
                </div>
                <div class="show__desc">
                  <h3>{{item.name}}</h3>
                  <p>{{item.remark}}</p>
                </div>
              </div>
              <div class="show__bottom">
                <div class="small__line"></div>
                <span><i></i>{{index<10 ? '0'+(index+1) : index+1}}</span>
              </div>
            </li>
          </ul>
          <div class="more__box" style="padding-bottom: 20px; height: 40px" v-show="sceneList && sceneList.length > 4">
            <a href="javascript:void(0);" @click="isMoreShow = !isMoreShow" class="more">{{isMoreShow ? '[ 更多 ]' : '[ 收起 ]'}}</a>
          </div>
        </div>
        <!-- 产品展示结束 -->
        <!-- 产品介绍 -->
        <div class="production__recommend">
          <h2 class="area-title">产品介绍</h2>
          <borrowList :data-list="productionList" />
          <div class="more__box" v-show="productionList && productionList.length>=3">
            <a href="javascript:void(0);" class="more" @click="$router.push('/borrow')">[ 更多 ]</a>
          </div>
        </div>
        <!-- 产品介绍结束 -->
      </div>
    </div>
    <div class="section-contianer consultants">
      <!-- 人员展示 -->
      <div class="consultants__bg">
        <div class="consultats__shadow"></div>
        <div class="consultants__anglebox">
          <div class="consultants__anglebox__left"></div>
          <div class="consultants__anglebg"></div>
          <div class="consultants__anglebox__right"></div>
        </div>
      </div>
      <div class="main-container" v-show="consultants.length !== 0">
        <div class="consultants__show">
          <h2 class="area-title">业务咨询</h2>
          <div class="counserlorSwiper">
            <swiper
              :is-pagination="consultantsIsPagination"
              :pagination="'consultants__pagination'"
              :calculateHeight="true"
              :navigation="false"
              :autoplay="consultantsAutoplay"
              :loop="consultantsLoop"
              :slides-per-view="3"
              :on-touch-start="consultantTouchStart"
              :on-touch-end="consultantTouchEnd"
              ref="consultantsSwiper">
              <swiper-item v-for="(item, index) in consultants" :key="index">
                <div class="consultants__item">
                  <div class="consultants__item-box clearfix" :counselorId="item.uid">
                    <div class="consultants__img">
                      <img :src="item.logoUrl" :alt="item.name">
                    </div>
                    <div class="consultants__desc">
                      <div class="consultants__name">{{item.name}}</div>
                      <div class="consultants__job">{{item.profession}}</div>
                      <div class="consultants__phone"><span class="iconfont phone">&#xe657;</span>：{{prefix(item.phone)}}</div>
                      <div class="consultants__wechat"><span class="iconfont wechat">&#xe758;</span>：{{item.wechat}}</div>
                      <div class="consultants__order">立即预约</div>
                    </div>
                  </div>
                </div>
              </swiper-item>
            </swiper>
            <div class="more__box" style="padding-bottom: 0; height: 20px; margin-top: -10px">
              <a href="javascript:void(0);" @click="$router.push('/consultant/counserlor')" class="more">{{'[ 更多 ]'}}</a>
            </div>
          </div>
        </div>
      </div>
      <!-- 推荐文章 -->
      <div class="articles">
        <div class="main-container" v-show="showAritcles">
          <div class="articles__recommend">
            <h2 class="area-title">文章推荐</h2>
            <typebar @on-item-click="onTypeChange" :loan-type-arr="loanTypeArr" :selected-index="selectedLoanTypeIndex"/>
            <div class="articles-list">
              <datagrid
                @on-item-click="onItemClick"
                :articleList="articleList"/>
            </div>
            <!-- <div class="message" ref="message" v-show="articleList && articleList.length === 0"></div> -->
            <Loading
              v-show="articleList && articleList.length === 0"
              :height="100"
              :is-no-more="articleListNoMore"/>
            <div class="more__box">
              <a href="javascript:void(0);" class="more" @click="$router.push('/consultant/case-share')">[ 更多 ]</a>
            </div>
          </div>
          <div class="line"></div>
        </div>

      <!--合作机构-->
        <div class="main-container" v-show="partnerPictureList.length !== 0">
          <div class="cooperator">
            <h2 class="area-title">合作单位</h2>
            <div class="cooperator-list clearfix">
              <div class="cooperator-item"  v-for="(item, index) in partnerPictureList" :key="index">
                <a class="cooperator-img" :href="item.linkAddress" target="_blank">
                  <img :src="item.picturePath" :alt="item.partnerName">
                </a>
              </div>
            </div>
          </div>
        </div>
      <!-- 关注我们 -->
        <div class="main-container">
          <div class="attention__us">
            <h2 class="area-title">关注我们</h2>
            <div class="row row-bottom text-center">
              <a class="col-xs-4 list" @click="goWechat" style="cursor:pointer">
                <span>
                  <img src="/static/img/wechat-qrcode.png" alt="" width="160">
                </span>
                <div class="page-caption">
                  <h3 class="caption">伟嘉安捷官方微信</h3>
                  <div class="point"></div>
                  <p class="bottom">搜索公众号<span>“伟嘉安捷”</span></p>
                </div>
              </a>
              <a class="col-xs-4 list" @click="goWebsite" style="cursor:pointer">
                <span>
                  <img src="/static/img/website-qrcode.png" alt="" width="160">
                </span>
                <div class="page-caption">
                  <h3 class="caption">伟嘉安捷手机官网</h3>
                  <div class="point"></div>
                  <p class="bottom">提供一站式贷款服务</p>
                </div>
              </a>
              <a class="col-xs-4 list" style="cursor:pointer">
                <span>
                  <img src="/static/img/app-qrcode.png" alt="" width="160">
                </span>
                <div class="page-caption">
                  <h3 class="caption">伟嘉安捷官方APP</h3>
                  <div class="point"></div>
                  <p class="bottom">专业房产金融服务App</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--弹框-->
    <!--<home-dialog></home-dialog>-->
    <!--广告图-->
    <div class="advertising" v-show="isShow">
      <div class="advertising-wrap">
        <div class="close_wrap pull-right" @click="isShow=false">
          <img src="/static/img/advertising-close.png" alt="">
        </div>
        <div class="advertising-text">
          <div class="advertising-text-wrap pull-left">
            <p style="font-size: 40px;">伟&nbsp;嘉&nbsp;安&nbsp;捷&nbsp;客&nbsp;服&nbsp;电&nbsp;话</p>
            <p style="font-size: 25px;">服&nbsp;务&nbsp;时&nbsp;间&nbsp;：&nbsp;{{ custServiceTime[0] && custServiceTime[0].customerServiceTime }}</p>
          </div>
          <div class="advertising-tel-wrap pull-left">
            <p style="font-size: 76px;">{{remarks}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Banner from '@/components/home/banner'
  import Swiper from '@/components/swiper/swiper'
  import SwiperItem from '@/components/swiper/swiper-item'
  import Typebar from '@/components/combo/typebar'
  import BorrowList from '@/components/borrow/list'
  import Datagrid from '@/components/combo/datagrid'
  import Loading from '@/components/combo/loading'
  import Floating from '@/components/combo/floating'
  // import { bindEvent } from '@/util/index'

  import HomeDialog from '@/components/combo/dialog'
  const SHOWNUMBER = 10 // 推荐文章默认显示的条数

  export default {
    name: 'Home',
    components: {
      Swiper,
      SwiperItem,
      Typebar,
      Datagrid,
      BorrowList,
      Loading,
      Floating,
      Banner,
      HomeDialog
    },
    data () {
      return {
        // banners: [],
        banners: {},
        isMoreShow: true,
        sceneList: [],
        productionList: [],
        consultants: [],
        // consultantsArr: [],
        selectedCounselorIndex: 1, // 贷款顾问被选中的顾问
        consultant: {},
        // skillMap: [],
        // tagMap: [],
        articleList: [],
        showAritcles: false,
        // leftList: [],
        // rightList: [],
        showNumber: SHOWNUMBER,
        loanTypeArr: [],
        // copyRightMap: new Map(),
        selectedLoanTypeIndex: null,
        articleListNoMore: false,
        consultantsAutoplay: 0,
        consultantsLoop: false,
        consultantsIsPagination: false,
        isShow: true,
        custServiceTime: {},
        remarks: '',
        partnerPictureList: []
      }
    },
    created () {
      this.remarks = this.$store.state.city.remarks
      this._fetchBanners()
      // this._getCopyRightTag()
      this.refresh()
    },
    mounted () {
      this.$swiper = this.$refs.swiper
      this.$consultantsSwiper = this.$refs.consultantsSwiper
      this.onTypeChange()
      this.serviceTime()
    },
    watch: {
      '$store.state.city': 'onCityChange',
      // banners (list) {
      //   if (list && list.length) {
      //     this.$nextTick(() => {
      //       if (this.$swiper) {
      //         this.$swiper.destroy()
      //         this.$swiper.init()
      //       }
      //     })
      //   }
      // },
      consultants (val) {
        if (val && val.length) {
          this.$nextTick(() => {
            if (this.$consultantsSwiper) {
              this.$consultantsSwiper.destroy()
              this.$consultantsSwiper.init()
              // this.consultantSlideTo()
            }
          })
        }
      }
      // consultants (val) {
      //   this.consultantsArr = []
      //   if (val && val.length) {
      //     this.consultant = this.consultants[1] || {}
      //     for (let i = 0; i < Math.ceil(this.consultants.length / 3); i++) {
      //       this.consultantsArr[i] = []
      //       this.consultants[i * 3] && this.consultantsArr[i].push(this.consultants[i * 3])
      //       this.consultants[i * 3 + 1] && this.consultantsArr[i].push(this.consultants[i * 3 + 1])
      //       this.consultants[i * 3 + 2] && this.consultantsArr[i].push(this.consultants[i * 3 + 2])
      //     }
      //     this.consultantSlideTo()
      //   }
      // }
      // skillMap: 'mapChange',
      // consultant: 'mapChange',
      // articleList: 'articlesChange'
    },
    methods: {
      prefix (str) {
        if (str.length !== 11) return str
        return str.replace(/(\d{3})(\d{4})(\d{4})/, ($0, $1, $2, $3) => {
          return $1 + '-' + $2 + '-' + $3
        })
      },
      _fetchData (url, data, done) {
        return this.$http({url, data, done})
      },
      // _getCopyRightTag () {
      //   let vm = this
      //   this.$http({
      //     url: '/getLookupCdeList.jhtml',
      //     data: {
      //       typeCode: 20008005
      //     },
      //     done (result) {
      //       result.forEach(item => {
      //         vm.copyRightMap.set(item.cdeCode, item.cdeName)
      //       })
      //       vm.copyRightMap = Object.assign(new Map(), vm.copyRightMap)
      //     }
      //   })
      // },
      // 获取贷款顾问技能
      // getSkillMap (skillScore) {
      //   let skill = []
      //   this.loanTypeArr.forEach((loanType) => {
      //     if ((skillScore & loanType.code) === loanType.code) {
      //       skill.push(loanType.name)
      //     }
      //   })
      //   return skill
      // },
      /**
       * 获取轮播banner
       * @private
       */
      _fetchBanners () {
        this._fetchData('/getBanners.jhtml', {}, (list) => {
          // this.banners = list.map((item) => {
          //   let o = {
          //     url: item.url,
          //     src: 'javascript:;'
          //   }
          //   if (item.type > 0) {
          //     o.src = item.src
          //   }
          //   if (item.type - 0 === 2) {
          //     o.target = '_blank'
          //   }
          //   return o
          // })
          this.banners = Object.assign({}, list)
        })
      },
      /**
       * 更换城市，重新获取相关城市数据
       */
      refresh () {
        this._getLoanTypeArr()
        this._fetchSceneByCity()
        this._fetchProductByCity()
        this.fetchCounserlorByIndex()
        this.getPartnerPictureList()
      },
      /**
       * 改变城市
       * @param city
       */
      onCityChange (city) {
        // this.onTypeChange()
        // this.refresh()
        this.remarks = this.$store.state.city.remarks
        window.location.reload()
      },
      getPartnerPictureList () {
        let vm = this
        this.$http({
          url: '/getPartnerPictureList.jhtml',
          data: {
            cityNo: this.$store.state.city.code
          },
          done (result) {
            vm.partnerPictureList = [].concat(result)
          }
        })
      },
      _getLoanTypeArr () {
        let vm = this
        this.$http({
          url: '/getLoanTypeMap.jhtml',
          data: {
            cityNo: this.$store.state.city.code
          },
          done (result) {
            vm.loanTypeArr = [].concat(result)
          }
        })
      },
      /**
       * skillMap发生改变触发事件
       */
      // mapChange () {
        // if (this.skillMap.length && this.consultant && this.consultant.skill) {
        //   let keys = this.consultant.skill.split(',')
        //   let result = []
        //   keys.forEach((key) => {
        //     for (let i = 0, len = this.skillMap.length; i < len; i++) {
        //       if (key === this.skillMap[i].cdeCode + '') {
        //         result.push(this.skillMap[i].cdeName)
        //         break
        //       }
        //     }
        //   })
        //   this.$set('consultant', 'skillName', result.join('、'))
        // }
      // },
      /**
       * 获取某个城市支持的场景
       */
      _fetchSceneByCity () {
        this._fetchData('/getSceneByCity.jhtml', {
          cityNo: this.$store.state.city.code
        }, (list) => {
          this.sceneList = [].concat(list)
        })
      },
      /**
       * 获取对应城市热门产品
       */
      _fetchProductByCity () {
        this._fetchData('/getProductByCity.jhtml', {
          cityNo: this.$store.state.city.code,
          isPage: 'y',
          pageSize: 3,
          pageNumber: 1
        }, (list) => {
          this.productionList = [].concat(list)
        })
      },
      /**
       * 点击场景跳转
       * @param index
       */
      onSceneClick (item) {
        this.$router.push({
          path: '/borrow',
          query: {
            sceneid: item.id
          }
        })
      },
      /**
       * 获取首页推荐贷款顾问
       */
      fetchCounserlorByIndex () {
        let vm = this
        this.$http({
          url: '/getPushCounselorsByIndex.jhtml',
          data: {
            cityNo: this.$store.state.city.code
          },
          done (list) {
            vm.consultants = [].concat(vm.$shuffle(list.splice(0, 10)))
            vm.consultantsLoop = vm.consultants.length > 3
            vm.consultantsAutoplay = vm.consultants.length > 3 ? 3000 : 0
            vm.consultantsIsPagination = vm.consultants.length > 3
          }
        })
      },
      // getConsultants (index) {
      //   let consultants = []
      //   for (let i = 0; i < 3; i++) {
      //     consultants.push(this.consultants[index * 3])
      //     this.consultants[index * 3 + 1] && consultants.push(this.consultants[index * 3 + 1])
      //     this.consultants[index * 3 + 2] && consultants.push(this.consultants[index * 3 + 2])
      //   }
      //   return consultants
      // },
      consultantTouchStart (swiper, event) {
        this.consultentsStartX = event.screenX
      },
      consultantTouchEnd (swiper, event) {
        this.consultentsEndX = event.screenX
        if (Math.abs(this.consultentsStartX - this.consultentsEndX) < 5) {
          let target = event.target
          let result = target
          while (result.className.indexOf('consultants__item-box') === -1) {
            result = result.parentNode
          }
          let id = result.getAttribute('counselorId')
          if (target.className === 'consultants__order') {
            // 贷款预约统计功能
            this.loanReservationStatistics(id)
            // 贷款预约功能
            this.order(id)
          } else {
            this.$router.push('/consultant/consultant-articles/' + id)
          }
        }
      },
      /**
       * 贷款顾问跳转
       * @param item
       */
      // consultantSlideTo () {
      //   this.$nextTick(() => {
      //     var listGropu = this.$consultantsSwiper.$el.getElementsByClassName('consultants__item-box')
      //     for (let i = 0; i < listGropu.length; i++) {
      //       let item = listGropu[i]
      //       let id = item.getAttribute('counselorId')
      //       bindEvent(item, 'mousedown', (e) => {
      //         e.stopPropagation()
      //         item.startX = e.pageX
      //       })
      //       bindEvent(item, 'mouseup', (e) => {
      //         e.stopPropagation()
      //         if (Math.abs(item.startX - e.pageX) < 5 && e.target.className !== 'consultants__order') {
      //           this.$router.push('/consultant/consultant-articles/' + id)
      //         }
      //       })
      //       let orderBtn = item.getElementsByClassName('consultants__order')[0]
      //       bindEvent(orderBtn, 'mousedown', (e) => {
      //         e.stopPropagation()
      //         orderBtn.startX = e.pageX
      //       })
      //       bindEvent(orderBtn, 'mouseup', (e) => {
      //         e.stopPropagation()
      //         if (Math.abs(orderBtn.startX - e.pageX) < 5 && e.target.className === 'consultants__order') {
      //           // 贷款预约统计功能
      //           this.loanReservationStatistics(id)
      //           // 贷款预约功能
      //           this.order(id)
      //         }
      //       })
      //     }
      //   })
      // },
      // 贷款预约统计
      loanReservationStatistics (counselorId) {
        let from = this.$route.path.split('/').some(str => str === 'article') ? 'article' : 'counselor'
        let articleId = this.$route.query.articleId || ''
        this.$http({
          url: '/loanReservationStatistics.jhtml',
          data: {
            from: from,
            counselorId: counselorId,
            articleId: articleId
          }
        })
      },
      /**
       * 贷款预约
       * @param item
       */
      order (counselorId) {
        this.$store.commit('toggleAppointment', {show: true, id: counselorId})
      },
      /**
       * 查询对应贷款类型推荐文章
       * @param item
       */
      onTypeChange (index, item) {
        index !== null ? this.selectedLoanTypeIndex = index : this.selectedLoanTypeIndex = null
        this.articleList = []
        // this.$refs.message.innerText = '正在加载中。。。'
        this.articleListNoMore = false
        this._fetchData('/getPushArticlesByIndex.jhtml', {
          cityNo: this.$store.state.city.code,
          loanType: (item ? item.id : null)
        }, (list) => {
          setTimeout(() => {
            // 默认显示showNumber条数据，当数据超出showNumber则删除
            if (list.length > this.showNumber) {
              list.length = this.showNumber
            }
            this.articleList = [].concat(list)
            this.showAritcles = true
            if (this.articleList.length === 0) {
              if (item == null) {
                this.showAritcles = false
              }
              // this.$refs.message.innerText = '暂无数据'
              this.articleListNoMore = true
            }
          }, 200)
        })
      },
      /**
       * 查看贷款顾问推荐文章
       * @param item
       */
      onItemClick (item) {
        window.open(`/consultant/article/${item.author}?articleId=${item.id}`)
        // this.$router.push(`/consultant/article/${item.author}?articleId=${item.id}`)
      },
      goWechat () {
        window.open('/wechat')
      },
      goWebsite () {
        window.open('/website')
      },
      /**
       * 获取客服时间
       * @param item
       */
      serviceTime () {
        let vm = this
        this.$http({
          url: '/time/getCustSerTime.jhtml',
          data: {
            key: 1
          },
          done (result) {
            vm.custServiceTime = [].concat(result)
          }
        })
      },
      goUrl (item) {
        console.log(11111111)
        item = 'www.baidu.com'
        window.location.href = item
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../stylus/mixin'
  .home-entry
    position relative
    top -60px
  // 每个区域的标题样式
  .area-title
    border-left 6px solid rgb(82, 100, 211)
    font-size 18px
    padding-left 14px
    height 30px
    letter-spacing 6px
    line-height 30px
    margin 0
  // 更多样式
  .more__box
    text-align right
    height 52px
    padding-bottom 30px
    margin-bottom 2px
    .more
      text-decoration none
      font-size 14px
      color #333
      &:active, &:hover
        color #2b9efc
  // 产品区域容器
  .section-container
    min-width 1180px
  .production
    background-image url(/static/img/bg1.png)
    background-repeat no-repeat
    background-position center top
    background-color #fff
    background-size cover
  // 版心容器
  .main-container
    margin 0 auto
    width 1180px !important
  // 产品展示开始
  .production__show
    .show__box
      margin 0
      padding 0
      padding-top 46px
    .show__item
      float left
      list-style none
      margin-right 33px
      &:nth-child(4n)
        margin-right 0
    .show__top
      width 270px
      height 311px
      cursor pointer
      padding 13px 12px 0
      box-sizing border-box
      background-color #fff
      border-radius 5px
      box-shadow 0px 1px 15px 3px rgba(0, 0, 0, 0.16)
      .show__img
        border-radius 3px
        border 1px solid rgb(238, 238, 238)
        img
          display block
          border-radius 3px
          width 230px
          height 90px
          margin 6px auto
      .show__desc
        margin-left 7px
        h3
          margin 26px 0 0 0
          font-size 30px
          ellipsis()
        p
          height 100px
          overflow hidden
          margin 17px 0 0 0
          font-size 18px
    .show__bottom
      padding 26px 0 8px
      .small__line
        position relative
        top -2px
        left 4px
        width 30px
        height 2px
        background-color #e5e5e5
      span
        display inline-block
        padding 2px
        border-radius 3px
        font-size 18px
        margin-left 40px
        color rgb(137, 136, 136)
        i
          display block
          width 22px
          height 24px
          float right
          margin-left - 16px
          border-radius 3px
          background-color rgb(238, 238, 238)
  // 产品展示结束
  // 产品介绍开始
  // .production__recommend
  // 产品介绍结束
  // 借款顾问开始
  .consultants
    background-color #fff
    .consultants__bg
      position relative
      height 190px
      background-image url(/static/img/consultants-section-bg.png)
      background-position center
      background-repeat no-repeat
      background-size cover
      margin-bottom -78px
    .consultats__shadow
      position absolute
      width 100%
      height 100%
      background-color rgba(0, 0, 0, 0.5)
    .consultants__anglebox
      position relative
      top 112px
      height 78px
      overflow hidden
    .consultants__anglebox__left, .consultants__anglebox__right
      width 50%
      position absolute
      top 0
      height 100%
      background-color #fff
    .consultants__anglebox__left
      left -280px
    .consultants__anglebox__right
      right -280px
    .consultants__anglebg
      position relative
      left 50%
      margin-left -282px
      top 0
      width 0
      height 0
      border-width 76px 282px
      border-style solid
      border-color transparent #fff #fff #fff
    .consultants__show
      position relative
      padding 58px 28px 0
      width 1236px
      margin-left -28px
      border 1px dotted rgba(0, 0, 0, 0.5)
      border-top 0
      .counserlorSwiper
        padding 60px 0 10px
      .consultants__item
        float left
        padding 14px 19px
        width 392px
        height 228px
        background-image url(/static/img/consultant-item-bg.png)
        background-repeat no-repeat
        background-position 5px top
        .consultants__item-box
          cursor pointer
          padding 10px
      .consultants__img
        float left
        width 144px
        height 180px
        border-radius 4px
        overflow hidden
        border 1px solid rgb(238, 238, 238)
        img
          display block
          width 100%
          height 100%
      .consultants__desc
        float right
        width 186px
        text-align center
        padding-top 6px
        .consultants__name, .consultants__job
          width 72px
          height 30px
          line-height 30px
          font-size 14px
          font-weight bold
          margin 0 auto
          text-align center
          border-bottom 1px solid #e4e4e4
          letter-spacing 2px
        .consultants__name
          width 72px
          ellipsis()
        .consultants__job
          width 128px
          font-weight normal
          font-size 12px
          ellipsis()
        .consultants__phone, .consultants__wechat
          width 150px
          line-height 20px
          font-size 14px
          font-weight bold
          margin 0 auto
          text-align left
          margin-top 10px
          ellipsis()
          .iconfont.phone,.iconfont.wechat
            text-align center
            width 18px
            float left
            margin-top 1px
            font-size 16px
            color #848f9e
          .iconfont.wechat
            font-size 18px
            color #73b666
        .consultants__order
          margin 10px auto 0
          cursor pointer
          width 144px
          letter-spacing 4px
          text-indent 2px
          height 36px
          line-height 36px
          border-radius 5px
          color #fff
          background-color rgb(43, 158, 252)
  // 借款顾问结束
  // 推荐文章开始
  .articles
    width 100%
    position relative
    padding-bottom 82px
    background-image url(/static/img/bg2.png)
    background-repeat no-repeat
    background-position center 106px
    background-size cover
    // background-color #fff
    .articles__recommend
      position relative
      padding-top 56px
      .more__box
          margin-top 10px
      .articles-list
        display table
        width 100%
        border-collapse collapse
        border-spacing 0
        table-layout fixed
        // .datagrid
        //   display table-cell
        //   width 50%
        //   &.bordered
        //     border-left 3px dotted #1a4369
        //   .item__box
        //     display block
        //     color #1a4369
        //     text-decoration none
        //     font-size 0
        //     span
        //       vertical-align middle
        //       display inline-block
        //       font-size 14px
        //       line-height 20px
        //   .tag
        //     margin-right 5px
        //   .title
        //     max-width 394px
        //     ellipsis()
        //   .date
        //     float right
        //   .item__box:hover
        //     color rgb(82, 210, 255)
  // 推荐文章结束
  // 合作单位开始
  .cooperator
    padding-top 26px
    .cooperator-list
      margin-top 16px
      .cooperator-item
        float left
        width 235px
        height 95px
        margin-bottom 10px
        margin-right 60px
        .cooperator-img
          display inline-block
          padding 20px 20px
          width 100%
          height 100%
          img
            width 100%
            height 100%
  // 关注我们开始
  .attention__us
    padding-top 26px
    .row-bottom
      margin 50px 0 0
      .list
        display block
        margin 0 30px
        padding-top 40px
        width 330px
        height 430px
        text-decoration none
        background-color #fff
        background-image url("/static/img/home-bottom-1.png")
        background-repeat no-repeat
        background-position center 40px
        border-radius 5px
        border 1px solid rgb(242, 242, 242)
        &:hover
          box-shadow 0 4px 15px 3px rgba(0,0,0,0.16)
        // &:last-child
        //   background-image url("/static/img/home-bottom-2.png")
        > span
          display block
          font-size 90px
          margin-top 10px;
          height 170px
          img
            display block
            margin 0 auto
        .iconfont
          font-size: 200px;
          color: #1a4369;
          line-height: 160px;
        .caption
          margin-top 30px
          margin-bottom 20px
          font-size 22px
          color #2a2b2a
          font-weight normal
        .bottom
          font-size 18px
          margin-top 20px
          color #666
          span
            color #2b9efc
  // 关注我们结束

  // 广告图
  .advertising
    position fixed
    left 0
    bottom 0
    z-index 10
    width 100%
    height 140px
    background url('/static/img/advertising-bg.png') no-repeat
    background-size cover
    .advertising-wrap
      width 1180px
      height 140px
      margin 0 auto
      .close_wrap
        margin-top 10px
        cursor pointer
      .advertising-text
        padding-top 25px
        p
          margin 0
          font-family "Microsoft YaHei"
          color #fff
          text-shadow:#333 1px 0 0,#333 0 1px 0,#333 -1px 0 0,#333 0 -1px 0
        .advertising-text-wrap
          margin-right 72px

</style>



// WEBPACK FOOTER //
// home.vue?51cf764e